<template>
  <MDBRow>
    <MDBCol cols="12" lg="6" xl="4" class="mb-4" v-for="(data, i) in contactData" :key="i"
      :class="`${data.show ? '' : 'd-none'}`">
      <Card :data="data" :linkText="data.linkText" v-if="data.show" :simpleLink="data.simpleLink" :target="data.target"
        class="h-100" />
    </MDBCol>
  </MDBRow>
</template>

<script setup>
import { MDBRow, MDBCol } from "mdb-vue-ui-kit";
import Card from "@/components/General/Card/index.vue";
import { useI18n } from 'vue-i18n'

import { useTenantConfig } from "@/composables/useTenantConfig";
import { getShowServiceNumberPage, getShowStrategicPartners, getShowTouchIncentive, getShowBridgestoneContact, getShowPremiumPartnerContact } from "@/composables/useProfileFieldCheck";
import { computed } from "vue";

const { tenantConfig } = useTenantConfig();
const { showServiceNumberPage } = getShowServiceNumberPage(tenantConfig);
const { showStrategicPartners } = getShowStrategicPartners(tenantConfig);
const { showTouchIncentive } = getShowTouchIncentive(tenantConfig);
const { showBridgestoneContact } = getShowBridgestoneContact(tenantConfig);
const { showPremiumPartnerContact } = getShowPremiumPartnerContact(tenantConfig)

const { t } = useI18n()

const contactData = computed(() => [
  {
    name: t("contactService.contact.categories.service.description"),
    link: { name: "service_number" },
    description: t("contactService.contact.categories.contact.short_desc"),
    image: require("@/assets/img/contact/service.png"),
    linkText: t("global.buttons.discover"),
    show: showServiceNumberPage(),
    simpleLink: false,
    target: '_self'
  },
  {
    name: t("contactService.contact.strategicPartners.cardTitle"),
    link: { name: "strategic_partners" },
    description: t("contactService.contact.strategicPartners.short_desc"),
    image: require("@/assets/img/contact/support_nl.jpg"),
    linkText: t("global.buttons.discover"),
    show: showStrategicPartners(),
    simpleLink: false,
    target: '_self'
  },
  {
    name: t("contactService.contact.categories.touch.title"),
    link: { name: 'touch_incentive' },
    description: t("contactService.contact.categories.touch.description"),
    image: require("@/assets/img/contact/ti_logo.png"),
    linkText: t("global.buttons.discover"),
    show: showTouchIncentive(),
    simpleLink: false,
    target: '_self'
  },
  {
    name: t("contactService.contact.categories.bridgestone.title"),
    link: { name: 'bridgestone_contact' },
    description: t("contactService.contact.categories.bridgestone.short_desc"),
    image: require("@/assets/img/contact/bs_logo.png"),
    linkText: t("global.buttons.discover"),
    show: showBridgestoneContact(),
    simpleLink: false,
    target: '_self',
    imageBoxHeight: '75px'
  },
  {
    name: t("contactService.contact.categories.dekouple.title"),
    link: { name: 'dekouple_contact' },
    description: t("contactService.contact.categories.dekouple.short_desc"),
    image: require("@/assets/img/contact/dekouple.png"),
    linkText: t("global.buttons.discover"),
    show: showBridgestoneContact(),
    simpleLink: false,
    target: '_self',
    imageBoxHeight: '75px'
  },
  {
    name: t("contactService.contact.categories.premium_partner.title"),
    link: { name: 'premium_partner_contact' },
    description: t("contactService.contact.categories.premium_partner.short_desc"),
    image: require("@/assets/img/contact/premium_partner.jpg"),
    linkText: t("global.buttons.discover"),
    show: showPremiumPartnerContact(),
    simpleLink: false,
    target: '_self',
    imageWidth: '35%',
    imageBoxHeight: '75px'
  },
]);
</script>
